import React from 'react';

import Marked from '../../Marked';
import './index.css';
import quote from '../../../img/blog-quote.svg';

export default ({ text }) => {
  return (
    <section className="blog-quote  secondary-padding">
      <img src={quote} alt="Hero quote" />
      <Marked className="text blog-left" content={text} />
    </section>
  );
};
